import React, { useState, useEffect } from "react";
import "./style.scss";
import { Link, useParams } from "react-router-dom";
import {
  useApplyCouponMutation,
  useGetCartDataQuery,
  usePlaceOrderMutation,
  useReduceCartQuantityMutation,
  useRemoveCartItemMutation,
  useUpdateCartQuantityMutation,
} from "../../../services/cartPageAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripePaymentForm from "../stripePayment";
import Modal from "react-modal";
import PaypalComponent from "../paypalComponent";
import {
  useGetColorThemeQuery,
  useGetPaymentMOdesQuery,
} from "../../../services/commonAPI";
import Loader from "../fullPageLoader";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { useGetBillingAddressDataQuery } from "../../../services/myAccountAPI";

// const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

function Checkoutform() {
  const navigate = useNavigate();
  const { cartId } = useParams();
  const [isModalOpen, setStripeModalOpen] = useState(false);
  console.log("isModalOpen", isModalOpen);
  const { data: colorthemeData } = useGetColorThemeQuery();
  const { data: paymentmodes } = useGetPaymentMOdesQuery();
  const [stripePromiseKey, setStripeKey] = useState(null);
  const [errors, setErrors] = useState({});


  const stripeMode = paymentmodes?.payment_modes?.find(
    (mode) => mode.name === "stripe"
  );
  const stripePublicKey = stripeMode?.public_key || null;
  // const stripeSecretKey = stripeMode?.secret_key || null;
  // const stripewebookId = stripeMode?.webhook_id || null;

  // const paypalMode = paymentmodes?.payment_modes?.find((mode) => mode.name === "paypal");
  // const paypalPublicKey = stripeMode?.public_key || null;
  // const paylpalSecretKey = stripeMode?.secret_key || null;

  const decryptData = (encryptedData) => {
    try {
      console.log("encryptedData", encryptedData);

      if (!encryptedData) {
        console.error("Error: Encrypted data is null or empty!");
        return null;
      }

      const key = CryptoJS.enc.Hex.parse(
        process.env.REACT_APP_CRYPTOJS_AES_KEY
      );
      const iv = CryptoJS.enc.Hex.parse(process.env.REACT_APP_CRYPTOJS_AES_IV);

      if (!key || !iv) {
        console.error("Decryption key or IV is missing!");
        return null;
      }

      const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

      if (!decryptedText) {
        console.error("Decryption failed: Empty result");
        return null;
      }

      console.log("Decrypted:", decryptedText);

      return JSON.parse(decryptedText);
      // Return the decrypted text directly (no JSON parsing)
      // return decryptedText.trim(); // Trim any extra whitespace
    } catch (error) {
      console.error("Error decrypting data:", error);
      return null;
    }
  };

  useEffect(() => {
    if (stripePublicKey) {
      const decryptedStripePublicKey = decryptData(stripePublicKey);
      console.log("decryptedStripePublicKey ", decryptedStripePublicKey);

      if (decryptedStripePublicKey) {
        const initializeStripe = async () => {
          const stripe = await loadStripe(decryptedStripePublicKey);
          setStripeKey(stripe);
        };
        initializeStripe();
      }
    }
  }, [stripePublicKey]);

  const validateForm = () => {
    let newErrors = {};
    if (!formData.firstName.trim()) newErrors.firstName = "Name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    if (!formData.payment_type) newErrors.payment_type = "Payment Type is required";
    if (!formData.country) newErrors.country = "Country/Region is required";
    if (!formData.streetAddress1) newErrors.streetAddress1 = "Street Address is required";
    if (!formData.city) newErrors.city = "Town/city is required";
    if (!formData.state) newErrors.state = "State is required";
    if (!formData.pinCode) {
      newErrors.pinCode = "Pin code is required";
    } else if (!/^\d+$/.test(formData.pinCode)) {
      newErrors.pinCode = "Pin code must contain only numbers";
    }

    // Check if phone is empty or contains non-numeric characters
    if (!formData.phone) {
      newErrors.phone = "Phone is required";
    } else if (!/^\d+$/.test(formData.phone)) {
      newErrors.phone = "Phone must contain only numbers";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };


  const validateFormForStripe = () => {
    let newErrors = {};
    if (!formData.firstName.trim()) newErrors.firstName = "Name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
  
    if (!formData.country) newErrors.country = "Country/Region is required";
    if (!formData.streetAddress1) newErrors.streetAddress1 = "Street Address is required";
    if (!formData.city) newErrors.city = "Town/city is required";
    if (!formData.state) newErrors.state = "State is required";
    if (!formData.pinCode) {
      newErrors.pinCode = "Pin code is required";
    } else if (!/^\d+$/.test(formData.pinCode)) {
      newErrors.pinCode = "Pin code must contain only numbers";
    }

    // Check if phone is empty or contains non-numeric characters
    if (!formData.phone) {
      newErrors.phone = "Phone is required";
    } else if (!/^\d+$/.test(formData.phone)) {
      newErrors.phone = "Phone must contain only numbers";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };


  // const decryptedStripePublicKey = decryptData(stripePublicKey);
  // console.log("decryptedStripePublicKey ", decryptedStripePublicKey);
  // // const stripePromise = loadStripe(decryptedStripePublicKey);

  // useEffect(() => {
  //   if (decryptedStripePublicKey) {
  //     const stripePromise = loadStripe(decryptedStripePublicKey);
  //     setStripeKey(stripePromise);
  //   }
  // }, [decryptedStripePublicKey]);

  const [isPaypalModalOpen, setPaypalModalOpen] = useState(false);

  const closePaypalModal = () => {
    setPaypalModalOpen(false);
  };

  const [isCouponModalOpen, setIsCouponModalOpen] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [isCouponSuccess, setIsCouponSuccess] = useState(null);

  const { data, error, isLoading, refetch } = useGetCartDataQuery();
  const [updateQuantity] = useUpdateCartQuantityMutation();
  const [reduceQuantity] = useReduceCartQuantityMutation();
  const [removeCartItem] = useRemoveCartItemMutation();
  const [applyCoupon, { isLoading: isApplyingCoupon }] =
    useApplyCouponMutation();

  useEffect(() => {
    refetch();
  }, [refetch]);

  const [
    placeOrder,
    { isLoading: isPlacingOrder, isError, isSuccess, error: SubmitError },
  ] = usePlaceOrderMutation(); // Use the mutation

  const [cartItems, setCartItems] = useState([]);
  const [totals, setTotals] = useState({
    subtotal_main_price: 0,
    subtotal_selling_price: 0,
    total_discount: 0,
    total_amount: 0,
    total_items: 0,
    discount_percentage: 0,
  });
  const [couponCode, setCouponCode] = useState("");
  const [message, setMessage] = useState("");
  const [appliedCoupons, setAppliedCoupons] = useState([]);
  console.log(disableButton);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    companyName: "",
    country: "",
    streetAddress1: "",
    streetAddress2: "",
    city: "",
    state: "",
    pinCode: "",
    phone: "",
    email: "",
    createAccount: false,
    shipDifferent: false,
    orderNotes: "",

    shippingFirstName: "",
    shippingLastName: "",
    shippingCompanyName: "",
    shippingCountry: "",
    shippingStreetAddress1: "",
    shippingStreetAddress2: "",
    shippingCity: "",
    shippingState: "",
    shippingPinCode: "",
    shippingPhone: "",
    shippingEmail: "",

    payment_type: null,
    paymentMethodId: "",
  });

  useEffect(() => {
    if (data?.success) {
      setCartItems(data.data);
      setTotals(data.totals);
      setAppliedCoupons(data.coupons || []);
    }
  }, [data]);

  const getAvailableStock = (product) => {
    if (!product.attributes || product.attributes.length === 0) {
      return 0;
    }
    const attribute = product.attributes[0];
    return attribute?.stock || 0;
  };

  const isOutOfStock = (product) => {
    const stock = getAvailableStock(product);
    return (
      stock === 0 || !product.attributes || product.attributes.length === 0
    );
  };

  // Cart functions
  const handleIncrement = async (item) => {
    const availableStock = getAvailableStock(item.product);
    const newQuantity = item.quantity + 1;

    if (newQuantity <= availableStock) {
      try {
        await updateQuantity({
          product_id: item.product_id,
          quantity: 1,
        }).unwrap();
        refetch();
      } catch (err) {
        console.error("Failed to update quantity:", err);
        alert("Failed to update quantity. Please try again.");
      }
    } else {
      alert("Cannot add more items. Stock limit reached.");
    }
  };

  const handleDecrement = async (item) => {
    if (item.quantity > 1) {
      try {
        await reduceQuantity({
          product_id: item.product_id,
        }).unwrap();
        refetch();
      } catch (err) {
        console.error("Failed to update quantity:", err);
        alert("Failed to update quantity. Please try again.");
      }
    }
  };

  const handleRemoveItem = async (item) => {
    try {
      await removeCartItem({
        product_id: item.product_id,
      }).unwrap();
      refetch();
    } catch (err) {
      console.error("Failed to remove item:", err);
    }
  };

  const handleApplyCoupon = async (e) => {
    e.preventDefault();

    if (!couponCode) {
      alert("Please enter a coupon code.");
      return;
    }

    try {
      const response = await applyCoupon({
        coupon_code: couponCode,
      }).unwrap();
      setMessage(response.message);
      setIsCouponSuccess(true);
      setCouponCode("");
      refetch();
      setIsCouponModalOpen(false);
    } catch (err) {
      console.error("Failed to apply coupon:", err);
      setMessage(
        err.data?.message || "Failed to apply coupon. Please try again."
      );
      setIsCouponSuccess(false);
    }
  };

  const handleFormChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : name === "payment_type"
            ? Number(value)
            : value,
    }));

    // Remove the error for the corresponding field when the user types
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",  // Clears the error for the field being updated
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    // Validate payment type
    if (formData.payment_type === null) {
      alert("Please select a payment method.");
      return;
    }

    // Merge streetAddress fields into one string before submission
    // const finalStreetAddress =
    //   `${formData.streetAddress1} ${formData.streetAddress2}`.trim();

    // const finalDiffStreetAddress = formData.shipDifferent
    //   ? `${formData.shippingStreetAddress1} ${formData.shippingStreetAddress2}`.trim()
    //   : "";

    const separator = "\u200B"; // Hidden separator

    const formatStreetAddress = (line1, line2) => {
      if (!line1) return line2 || ""; // If no line1, just return line2
      if (!line2) return line1; // If no line2, just return line1
      return line1.trim().endsWith(",")
        ? `${line1.trim()}${separator}${line2.trim()}`
        : `${line1.trim()}, ${separator}${line2.trim()}`;
    };

    const finalStreetAddress = formatStreetAddress(
      formData.streetAddress1,
      formData.streetAddress2
    );

    const finalDiffStreetAddress = formData.shipDifferent
      ? formatStreetAddress(
        formData.shippingStreetAddress1,
        formData.shippingStreetAddress2
      )
      : "";

    // Prepare the payload for the API
    const payload = {
      cart_id: cartId, // Assuming you have cartId from the URL or state
      payment_type: formData.payment_type, // Assuming you have a payment type field
      first_name: formData.firstName,
      last_name: formData.lastName,
      company_name: formData.companyName,
      country: formData.country,
      street_address: finalStreetAddress,
      town_city: formData.city,
      state: formData.state,
      pin_code: formData.pinCode,
      phone: formData.phone,
      email: formData.email,
      account_create: formData.createAccount ? 1 : 0,
      diff_ship_address: formData.shipDifferent ? 1 : 0,
      order_notes: formData.orderNotes,
      //   paymentMethodId: formData.paymentMethodId,
    };

    // Add shipping address fields if shipDifferent is true
    if (formData.shipDifferent) {
      Object.assign(payload, {
        ship_first_name: formData.shippingFirstName,
        ship_last_name: formData.shippingLastName,
        ship_company_name: formData.shippingCompanyName,
        ship_country: formData.shippingCountry,
        ship_street_address: finalDiffStreetAddress,
        ship_town_city: formData.shippingCity,
        ship_state: formData.shippingState,
        ship_pin_code: formData.shippingPinCode,
        ship_phone: formData.shippingPhone,
        ship_email: formData.shippingEmail,
      });
    }

    try {
      const response = await placeOrder(payload).unwrap();
      localStorage.setItem("OrderId", response.order_id);
      localStorage.setItem("OrderMainId", response.order_main_id);

      navigate("/payment-success");
    } catch (err) {
      setDisableButton(false);
    }
  };

  const handleSubmitDirectPurchase = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    // Merge streetAddress fields into one string before submission
    const finalStreetAddress =
      `${formData.streetAddress1} ${formData.streetAddress2}`.trim();
    const finalDiffStreetAddress = formData.shipDifferent
      ? `${formData.shippingStreetAddress1} ${formData.shippingStreetAddress2}`.trim()
      : "";

    // Prepare the payload for the API
    const payload = {
      cart_id: cartId, // Assuming you have cartId from the URL or state
      payment_type: 3,
      first_name: formData.firstName,
      last_name: formData.lastName,
      company_name: formData.companyName,
      country: formData.country,
      street_address: finalStreetAddress,
      town_city: formData.city,
      state: formData.state,
      pin_code: formData.pinCode,
      phone: formData.phone,
      email: formData.email,
      account_create: formData.createAccount ? 1 : 0,
      diff_ship_address: formData.shipDifferent ? 1 : 0,
      order_notes: formData.orderNotes,
      //   paymentMethodId: formData.paymentMethodId,
    };

    // Add shipping address fields if shipDifferent is true
    if (formData.shipDifferent) {
      Object.assign(payload, {
        ship_first_name: formData.shippingFirstName,
        ship_last_name: formData.shippingLastName,
        ship_company_name: formData.shippingCompanyName,
        ship_country: formData.shippingCountry,
        ship_street_address: finalDiffStreetAddress,
        ship_town_city: formData.shippingCity,
        ship_state: formData.shippingState,
        ship_pin_code: formData.shippingPinCode,
        ship_phone: formData.shippingPhone,
        ship_email: formData.shippingEmail,
      });
    }

    try {
      const response = await placeOrder(payload).unwrap();
      localStorage.setItem("OrderId", response.order_id);
      localStorage.setItem("OrderMainId", response.order_main_id);

      navigate("/payment-success");
    } catch (err) {
      setDisableButton(false);
    }
  };

  useEffect(() => {
    if (formData.payment_type === 0) {
      setStripeModalOpen(true);
    }
    // if (formData.payment_type === 1) {
    //   setPaypalModalOpen(true);
    // }
  }, [formData.payment_type]);

  const handleProceedtoPyment = () => {
    if (!validateForm()) return;
    if (formData.payment_type === 1) {
      setPaypalModalOpen(true);
    }
  };

  const accessToken = localStorage.getItem("access_token");
  const user_id = localStorage.getItem("gridMarker");

  // Fetch Billing Address Data
  const {
    data: billingAddressData,
    isLoading: isBillingLoading,
    error: billingError,
  } = useGetBillingAddressDataQuery(undefined, {
    skip: !accessToken || !user_id, // Skip the query if the user is not logged in
  });

  useEffect(() => {
    if (billingAddressData?.success) {
      // Check if data array is not empty
      if (billingAddressData.data.length > 0) {
        const billingAddress = billingAddressData.data[0]; // Access the first element

        // Update formData with the fetched billing address
        // setFormData((prev) => ({
        //   ...prev,
        //   firstName: billingAddress.first_name,
        //   lastName: billingAddress.last_name,
        //   companyName: billingAddress.company_name,
        //   country: billingAddress.country,
        //   streetAddress1: billingAddress.street_address.split("\n")[0], // Split street address into two parts
        //   streetAddress2: billingAddress.street_address.split("\n")[1] || "", // Handle cases where there's no second line
        //   city: billingAddress.town_city,
        //   state: billingAddress.state,
        //   pinCode: billingAddress.pin_code,
        //   phone: billingAddress.phone,
        //   email: billingAddress.email,
        // }));

        setFormData((prev) => {
          const [streetAddress1, streetAddress2 = ""] =
            billingAddress.street_address.split("\u200B");

          return {
            ...prev,
            firstName: billingAddress.first_name,
            lastName: billingAddress.last_name,
            companyName: billingAddress.company_name,
            country: billingAddress.country,
            streetAddress1,
            streetAddress2, // Ensure it defaults to an empty string if undefined
            city: billingAddress.town_city,
            state: billingAddress.state,
            pinCode: billingAddress.pin_code,
            phone: billingAddress.phone,
            email: billingAddress.email,
          };
        });
      } else {
        console.log("No billing address found."); // Log if data is empty
      }
    }
  }, [billingAddressData]);

  const handleTextKeyPress = (e) => {
    const regex = /^[a-zA-Z\s]$/;
    if (!regex.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleTextPaste = (field) => (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("Text");
    const cleanedText = pastedText.replace(/[^a-zA-Z\s]/g, "");
    setFormData((prev) => ({ ...prev, [field]: cleanedText }));
  };


  const handleTextKeyPressRemoveSpecialChar = (e) => {
    if (!/^[a-zA-Z0-9\s]$/.test(e.key)) {
      e.preventDefault();
    }
  };
  
  const handleTextPasteRemoveSpecialChar = (field) => (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("Text");
    const cleanedText = pastedText.replace(/[^a-zA-Z0-9\s]/g, "");
    setFormData((prev) => ({ ...prev, [field]: cleanedText }));
  };

  if (isLoading || isBillingLoading) return <Loader />;
  if (error || billingError) return <p>Failed to load data.</p>;

  return (
    <div className="checkout-form">
      <div className="container">
        <div className="mb-5">
          {!accessToken && !user_id && (
            <p>
              <b>Returning Customer </b>
              <Link
                to="/login"
                style={{
                  color:
                    colorthemeData?.color_themes?.[0]?.primary_color ||
                    "#a76d50",
                }}
              >
                Click here to login
              </Link>
            </p>
          )}
          <p>
            <b>Have a Coupon </b>
            {/* <Link to="/login">Click here to enter your code</Link> */}
            <button
              className="coupon-button"
              onClick={() => setIsCouponModalOpen(true)}
              style={{
                color:
                  colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50",
              }}
            >
              Click here to enter your code
            </button>

            {/* Coupon Modal */}
            {isCouponModalOpen && (
              <div className="modal-overlay">
                <div className="modal-content">
                  <button
                    className="close-modal"
                    onClick={() => setIsCouponModalOpen(false)}
                  >
                    &times;
                  </button>
                  <h3 className="modal-title">Apply Coupon</h3>
                  <br />
                  <form onSubmit={handleApplyCoupon} className="coupon-form">
                    <input
                      type="text"
                      placeholder="Enter Coupon Code"
                      value={couponCode}
                      onChange={(e) => setCouponCode(e.target.value)}
                      className="coupon-input"
                    />
                    <button
                      type="submit"
                      className="primary-button"
                      disabled={isApplyingCoupon}
                      style={{
                        backgroundColor:
                          colorthemeData?.color_themes?.[0]?.primary_color ||
                          "#a76d50",
                      }}
                    >
                      {isApplyingCoupon ? "Applying..." : "APPLY"}
                    </button>
                  </form>
                  {/* {message && <p className="coupon-message">{message}</p>} */}

                  {message && (
                    <p
                      className={`coupon-message ${isCouponSuccess === false
                        ? "error-text"
                        : "success-message"
                        }`}
                    >
                      {message}
                    </p>
                  )}
                </div>
              </div>
            )}

            {/* ---------------- */}
          </p>
        </div>
        {/* <form onSubmit={handleSubmit}> */}
        <h4 className="mb-4 mt-4">Billing Details</h4>
        <div className="row">
          <div className="col-md-6 col-sm-12 col-lg-6">
            <div className="left-div">
              <div className="row">
                {/* Billing Address Fields */}
                <div className="col-md-6 col-sm-12 col-lg-6">
                  <div className="mb-20">
                    <label>Full Name *</label>
                    <br />
                    <input
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleFormChange}
                      onKeyPress={handleTextKeyPress}
                      onPaste={handleTextPaste("firstName")}
                    />
                    {errors.firstName && <p className="error-text">{errors.firstName}</p>}
                  </div>
                </div>
                <div className="col-md-6 col-sm-12 col-lg-6">
                  <div className="mb-20">
                    <label>Last Name</label>
                    <br />
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleFormChange}
                      onKeyPress={handleTextKeyPress}
                      onPaste={handleTextPaste("lastName")}
                    />
                  </div>
                </div>
                <div className="col-md-12 col-sm-12 col-lg-12">
                  <div className="mb-20">
                    <label>Company Name (optional)</label>
                    <br />
                    <input
                      type="text"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleFormChange}
                      onKeyPress={handleTextKeyPressRemoveSpecialChar}
                      onPaste={handleTextPasteRemoveSpecialChar("companyName")}
                    />
                  </div>
                </div>
                <div className="col-md-12 col-sm-12 col-lg-12">
                  <div className="mb-20">
                    <label>Coutry/ Region*</label>
                    <br />
                    <input
                      type="text"
                      name="country"
                      value={formData.country}
                      onChange={handleFormChange}
                      onKeyPress={handleTextKeyPressRemoveSpecialChar}
                      onPaste={handleTextPasteRemoveSpecialChar("country")}
                    />
                    {errors.country && <p className="error-text">{errors.country}</p>}
                  </div>
                </div>
                <div className="col-md-12 col-sm-12 col-lg-12">
                  <div className="mb-20">
                    <label>Street Address*</label>
                    <br />
                    <input
                      type="text"
                      name="streetAddress1"
                      value={formData.streetAddress1}
                      onChange={handleFormChange}
                      required
                      placeholder="House number and street name"
                      className="mb-15"
                      onKeyPress={handleTextKeyPressRemoveSpecialChar}
                      onPaste={handleTextPasteRemoveSpecialChar("streetAddress1")}
                    />
                    {errors.streetAddress1 && <p className="error-text">{errors.streetAddress1}</p>}
                    <input
                      type="text"
                      name="streetAddress2"
                      value={formData.streetAddress2}
                      onChange={handleFormChange}
                      placeholder="Apartment, Suit, unit etc (optional)"
                      onKeyPress={handleTextKeyPressRemoveSpecialChar}
                      onPaste={handleTextPasteRemoveSpecialChar("streetAddress2")}
                    />
                  </div>
                </div>
                <div className="col-md-12 col-sm-12 col-lg-12">
                  <div className="mb-20">
                    <label>Town/City *</label>
                    <br />
                    <input
                      type="text"
                      name="city"
                      value={formData.city}
                      onChange={handleFormChange}
                      required
                      onKeyPress={handleTextKeyPressRemoveSpecialChar}
                      onPaste={handleTextPasteRemoveSpecialChar("city")}
                    />
                    {errors.city && <p className="error-text">{errors.city}</p>}
                  </div>
                </div>
                <div className="col-md-12 col-sm-12 col-lg-12">
                  <div className="mb-20">
                    <label>State *</label>
                    <br />
                    <input
                      type="text"
                      name="state"
                      value={formData.state}
                      onChange={handleFormChange}
                      required
                      onKeyPress={handleTextKeyPressRemoveSpecialChar}
                      onPaste={handleTextPasteRemoveSpecialChar("state")}
                    />
                    {errors.state && <p className="error-text">{errors.state}</p>}
                  </div>
                </div>
                <div className="col-md-12 col-sm-12 col-lg-12">
                  <div className="mb-20">
                    <label>PIN Code *</label>
                    <br />
                    <input
                      type="text"
                      name="pinCode"
                      value={formData.pinCode}
                      onChange={handleFormChange}
                      required
                      onKeyPress={handleTextKeyPressRemoveSpecialChar}
                      onPaste={handleTextPasteRemoveSpecialChar("pinCode")}
                    />
                    {errors.pinCode && <p className="error-text">{errors.pinCode}</p>}
                  </div>
                </div>
                <div className="col-md-12 col-sm-12 col-lg-12">
                  <div className="mb-20">
                    <label>Phone *</label>
                    <br />
                    <input
                      type="text"
                      name="phone"
                      value={formData.phone}
                      onChange={handleFormChange}
                      required
                      onKeyPress={handleTextKeyPressRemoveSpecialChar}
                      onPaste={handleTextPasteRemoveSpecialChar("phone")}
                    />
                    {errors.phone && <p className="error-text">{errors.phone}</p>}
                  </div>
                </div>
                <div className="col-md-12 col-sm-12 col-lg-12">
                  <div className="mb-20">
                    <label>Email Address *</label>
                    <br />
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleFormChange}
                      required
                    />
                    {errors.email && <p className="error-text">{errors.email}</p>}
                  </div>
                </div>

                {/* <div className="col-md-12 col-sm-12 col-lg-12">
                  <div className="mb-20">
                    <input
                      type="checkbox"
                      name="createAccount"
                      checked={formData.createAccount}
                      onChange={handleFormChange}
                    />{" "}
                    <label>Create an account?</label>
                  </div>
                </div> */}

                <div className="col-md-12 col-sm-12 col-lg-12">
                  <div className="mb-20">
                    <input
                      type="checkbox"
                      name="shipDifferent"
                      checked={formData.shipDifferent}
                      onChange={handleFormChange}
                    />{" "}
                    <label>Ship to a different address?</label>
                  </div>
                </div>

                {/* shipping address */}
                {formData.shipDifferent && (
                  <div className="shipping-address">
                    <h3>Shipping Details</h3>

                    <div className="row">
                      <div className="col-md-6 col-sm-12 col-lg-6">
                        <div className="mb-20">
                          <label>Full Name *</label>
                          <br />
                          <input
                            type="text"
                            name="shippingFirstName"
                            value={formData.shippingFirstName}
                            onChange={handleFormChange}
                            required={formData.shipDifferent}
                            onKeyPress={handleTextKeyPress}
                            onPaste={handleTextPaste("shippingFirstName")}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-12 col-lg-6">
                        <div className="mb-20">
                          <label>Last Name *</label>
                          <br />
                          <input
                            type="text"
                            name="shippingLastName"
                            value={formData.shippingLastName}
                            onChange={handleFormChange}
                            required={formData.shipDifferent}
                            onKeyPress={handleTextKeyPress}
                            onPaste={handleTextPaste("shippingLastName")}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12 col-sm-12 col-lg-12">
                      <div className="mb-20">
                        <label>Company Name (optional)*</label>
                        <br />
                        <input
                          type="text"
                          name="shippingCompanyName"
                          value={formData.shippingCompanyName}
                          onChange={handleFormChange}
                          onKeyPress={handleTextKeyPressRemoveSpecialChar}
                          onPaste={handleTextPasteRemoveSpecialChar("coshippingCompanyNamempanyName")}
                        />
                      </div>
                    </div>
                    <div className="col-md-12 col-sm-12 col-lg-12">
                      <div className="mb-20">
                        <label>Coutry/ Region*</label>
                        <br />
                        <input
                          type="text"
                          name="shippingCountry"
                          value={formData.shippingCountry}
                          onChange={handleFormChange}
                          required={formData.shipDifferent}
                          onKeyPress={handleTextKeyPressRemoveSpecialChar}
                          onPaste={handleTextPasteRemoveSpecialChar("shippingCountry")}
                        />
                      </div>
                    </div>
                    <div className="col-md-12 col-sm-12 col-lg-12">
                      <div className="mb-20">
                        <label>Street Address*</label>
                        <br />
                        <input
                          type="text"
                          name="shippingStreetAddress1"
                          value={formData.shippingStreetAddress1}
                          onChange={handleFormChange}
                          required={formData.shipDifferent}
                          placeholder="House number and street name"
                          className="mb-15"
                          onKeyPress={handleTextKeyPressRemoveSpecialChar}
                          onPaste={handleTextPasteRemoveSpecialChar("shippingStreetAddress1")}
                        />
                        <input
                          type="text"
                          name="shippingStreetAddress2"
                          value={formData.shippingStreetAddress2}
                          onChange={handleFormChange}
                          placeholder="Apartment, Suit, unit etc (optional)"
                        />
                      </div>
                    </div>
                    <div className="col-md-12 col-sm-12 col-lg-12">
                      <div className="mb-20">
                        <label>Town/City *</label>
                        <br />
                        <input
                          type="text"
                          name="shippingCity"
                          value={formData.shippingCity}
                          onChange={handleFormChange}
                          required={formData.shipDifferent}
                          onKeyPress={handleTextKeyPressRemoveSpecialChar}
                          onPaste={handleTextPasteRemoveSpecialChar("shippingCity")}
                        />
                      </div>
                    </div>
                    <div className="col-md-12 col-sm-12 col-lg-12">
                      <div className="mb-20">
                        <label>State *</label>
                        <br />
                        <input
                          type="text"
                          name="shippingState"
                          value={formData.shippingState}
                          onChange={handleFormChange}
                          required={formData.shipDifferent}
                          onKeyPress={handleTextKeyPressRemoveSpecialChar}
                          onPaste={handleTextPasteRemoveSpecialChar("shippingState")}
                        />
                      </div>
                    </div>
                    <div className="col-md-12 col-sm-12 col-lg-12">
                      <div className="mb-20">
                        <label>PIN Code *</label>
                        <br />
                        <input
                          type="text"
                          name="shippingPinCode"
                          value={formData.shippingPinCode}
                          onChange={handleFormChange}
                          required={formData.shipDifferent}
                          onKeyPress={handleTextKeyPressRemoveSpecialChar}
                          onPaste={handleTextPasteRemoveSpecialChar("shippingPinCode")}
                        />
                      </div>
                    </div>
                    <div className="col-md-12 col-sm-12 col-lg-12">
                      <div className="mb-20">
                        <label>Phone *</label>
                        <br />
                        <input
                          type="text"
                          name="shippingPhone"
                          value={formData.shippingPhone}
                          onChange={handleFormChange}
                          required={formData.shipDifferent}
                          onKeyPress={handleTextKeyPressRemoveSpecialChar}
                          onPaste={handleTextPasteRemoveSpecialChar("shippingPhone")}
                        />
                      </div>
                    </div>
                    <div className="col-md-12 col-sm-12 col-lg-12">
                      <div className="mb-20">
                        <label>Email Address *</label>
                        <br />
                        <input
                          type="email"
                          name="shippingEmail"
                          value={formData.shippingEmail}
                          onChange={handleFormChange}
                          required={formData.shipDifferent}
                        />
                      </div>
                    </div>
                  </div>
                )}

                <div className="col-md-12 col-sm-12 col-lg-12">
                  <div className="mb-20">
                    <label>Order notes(optional)</label>
                    <br />
                    <textarea
                      placeholder="Notes about your order"
                      rows={6}
                      name="orderNotes"
                      checked={formData.orderNotes}
                      onChange={handleFormChange}
                      onKeyPress={handleTextKeyPressRemoveSpecialChar}
                      onPaste={handleTextPasteRemoveSpecialChar("orderNotes")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-12 col-lg-6">
            <div className="right-div">
              <h4 className="text-center">Your Order</h4>
              <div className="product-details">
                <div className="d-flex justity-space-between">
                  <h5>Product</h5>
                  <h5>Subtotal</h5>
                </div>
                <hr />
                {cartItems.map((item) => {
                  const availableStock = getAvailableStock(item.product);
                  const outOfStock = isOutOfStock(item.product);
                  const variantCombination = item?.variant_details;
                  return (
                    <div
                      key={item.id}
                      className="d-flex justity-space-between align-items-center mb-4 cart-checkout"
                    >
                      <div className="d-flex align-items-center">
                        <button
                          onClick={() => handleRemoveItem(item)}
                          style={{ border: "none", background: "none" }}
                        >
                          <FontAwesomeIcon
                            icon={faClose}
                            style={{ marginRight: 8 }}
                          />
                        </button>
                        <img
                          src={item.product.product_main_image_url_large}
                          alt={item.product.product_name}
                          className="img-fluid"
                          width={70}
                          loading="lazy"
                        />
                        <div className="cart-to-button-container ml-20">
                          {/* Quantity Selector */}
                          <span>
                            {item?.product?.product_name}
                            {variantCombination?.length > 0 && (
                              <div style={{ fontSize: "13px", color: "gray" }}>
                                {variantCombination.map((v, index) => (
                                  <div key={index}><b>{v.variant_attribute_name}</b> : {v.variant_value_name}</div>
                                ))}
                              </div>
                            )}
                          </span>
                          <div className="quantity-selector">
                            <div>
                              <button
                                className="cart-counter-button"
                                onClick={() => handleDecrement(item)}
                                disabled={item.quantity <= 1 || outOfStock}
                              >
                                -
                              </button>
                              <button
                                className="cart-counter-button"
                                onClick={() => handleDecrement(item)}
                                disabled={item.quantity <= 1 || outOfStock}
                              >
                                {item.quantity}
                              </button>

                              <button
                                className="cart-counter-button"
                                onClick={() => handleIncrement(item)}
                                disabled={
                                  outOfStock || item.quantity >= availableStock
                                }
                              >
                                +
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>${item.line_total_selling_price}</div>

                    </div>

                  );
                })}
                <hr />

                <div className="d-flex justify-content-between mb-28">
                  <div>Subtotal</div>
                  <div>${totals.subtotal_selling_price}</div>
                </div>
                {appliedCoupons.length > 0 && (
                  <>
                    {/* <hr /> */}
                    <div>
                      <h6> Coupon Applied:</h6>
                      {appliedCoupons.map((coupon, index) => (
                        <div
                          key={index}
                          className="d-flex justify-content-between"
                        >
                          <div> {coupon.code}</div>
                          <div>
                            {" "}
                            -$
                            {coupon.type === "percentage"
                              ? coupon.discount_amount
                              : coupon.discount_amount}
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}
                <hr className="border-top-total" />
                <div className="d-flex justity-space-between align-items-center">
                  <div>
                    <b>Grand Total</b>
                  </div>
                  <div>${totals.total_amount}</div>
                </div>
              </div>
              {totals.total_amount > 0 && (
                <div className="payment-option">
                  {paymentmodes?.payment_modes
                    ?.filter((mode) => {
                      if (mode.name.toLowerCase() === "stripe") {
                        const stripeMode = paymentmodes?.payment_modes?.find(
                          (m) => m.name.toLowerCase() === "stripe"
                        );
                        return (
                          stripeMode?.public_key &&
                          stripeMode?.secret_key &&
                          stripeMode?.webhook_id
                        );
                      }

                      if (mode.name.toLowerCase() === "paypal") {
                        const paypalMode = paymentmodes?.payment_modes?.find(
                          (m) => m.name.toLowerCase() === "paypal"
                        );
                        return paypalMode?.public_key && paypalMode?.secret_key;
                      }

                      return mode.status === 1;
                    })
                    .map((mode) => {
                      let paymentValue =
                        mode.name.toLowerCase() === "stripe"
                          ? 0
                          : mode.name.toLowerCase() === "paypal"
                            ? 1
                            : mode.name.toLowerCase() === "cash on delivery"
                              ? 2
                              : mode.id;

                      return (
                        <div key={mode.id}>
                          <label>
                            <input
                              type="radio"
                              name="payment_type"
                              value={paymentValue}
                              checked={formData.payment_type === paymentValue}
                              onChange={handleFormChange}
                            />{" "}
                            {mode.name.charAt(0).toUpperCase() +
                              mode.name.slice(1)}
                          </label>

                        </div>
                      );
                    })}
                  {errors.payment_type && <p className="error-text">{errors.payment_type}</p>}
                  {/* Stripe Payment Form Section */}
                  {formData.payment_type === 0 && (
                    <div className="stripe-div">
                      <Elements stripe={stripePromiseKey}>
                        <StripePaymentForm
                          formData={formData}
                          cartId={cartId}
                          validateFormForStripe={validateFormForStripe}
                        />
                      </Elements>
                    </div>
                  )}
                </div>
              )}

              <div>
                {totals.total_amount > 0 ? (
                  (formData.payment_type === 1 ||
                    formData.payment_type === null) && (
                    <button
                      className="primary-button w-100 mt-4"
                      style={{
                        backgroundColor:
                          colorthemeData?.color_themes?.[0]?.primary_color ||
                          "#a76d50",
                      }}
                      onClick={handleProceedtoPyment}
                    >
                      Proceed to Payment
                    </button>
                  )
                ) : (
                  <button
                    className="primary-button w-100 mt-4"
                    disabled={isPlacingOrder}
                    style={{
                      backgroundColor:
                        colorthemeData?.color_themes?.[0]?.primary_color ||
                        "#a76d50",
                    }}
                    onClick={handleSubmitDirectPurchase}
                  >
                    {isPlacingOrder ? "Proceeding..." : "Order Now"}
                  </button>
                )}
              </div>

              <div>
                {formData.payment_type === 2 && (
                  <button
                    className="primary-button w-100 mt-4"
                    disabled={isPlacingOrder}
                    style={{
                      backgroundColor:
                        colorthemeData?.color_themes?.[0]?.primary_color ||
                        "#a76d50",
                    }}
                    onClick={handleSubmit}
                  >
                    {isPlacingOrder ? "Proceeding..." : "Order Now"}
                  </button>
                )}
              </div>
              {isSuccess && (
                <p className="success-message">Order Successfull</p>
              )}
              {isError && (
                <p className="error-text">
                  {SubmitError?.data?.message ||
                    SubmitError?.error ||
                    "Payment failed..!"}
                </p>
              )}
            </div>
          </div>
        </div>

        <Modal
          isOpen={isPaypalModalOpen}
          onRequestClose={closePaypalModal}
          contentLabel="Stripe Payment Modal"
          ariaHideApp={false}
          className="stripe-modal"
        >
          <button onClick={closePaypalModal} className="stripe-close">
            {" "}
            <FontAwesomeIcon icon={faClose} style={{ marginRight: 8 }} />
          </button>
          {formData.payment_type === 1 && (
            <div className="mt-5">
              <PaypalComponent
                amount={totals.total_amount}
                formData={formData}
                cartId={cartId}
              />
            </div>
          )}
        </Modal>
        {/* </form> */}
      </div>
    </div>
  );
}

export default Checkoutform;
